import { InjectionToken } from '@angular/core';
import { ITRWEAuthModuleConfig } from './interfaces/auth-module-config.interface';

export const TRWE_AUTH_MODULE_CONFIG = new InjectionToken<ITRWEAuthModuleConfig>(
  'TRWE_AUTH_MODULE_CONFIG'
);
